import { InputMask } from '@react-input/mask';

import { ReducersTypes } from "../redux/reducers/Models";
import { Link } from 'react-router-dom';
import Icon from '@/atomic/atoms/Icon';
import Loading from '@/atomic/atoms/Loading';
import LoginModal from '@/atomic/atoms/LoginModal';
import Modal from '@/atomic/atoms/Modal';
import Footer from '@/atomic/atoms/Footer';

export interface PropsView {
  toggleMenu: () => void;
  isVisibleMenu: boolean;
  user: ReducersTypes['userReducer'];
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  goToDebts: (e: React.ChangeEvent<HTMLFormElement>) => void;
  isDisabled: boolean;
  isLoading: boolean;
  error: boolean;
  isVisibleModal: boolean;
  toggleModal: () => void;
  isAcceptedTerms: boolean;
  isAcceptedPrivacy: boolean;
  toggleTerms: () => void;
  togglePrivacy: () => void;
  isVisibleModalLogin: boolean;
  toggleModalLogin: () => void;
  goToCreateAccount: () => void;
}

export default function IndexView({
  toggleMenu,
  isVisibleMenu,
  user,
  onChange,
  goToDebts,
  isDisabled,
  isLoading,
  error,
  isVisibleModal,
  toggleModal,
  isAcceptedTerms,
  isAcceptedPrivacy,
  toggleTerms,
  togglePrivacy,
  isVisibleModalLogin,
  toggleModalLogin,
  goToCreateAccount,
}: PropsView) {

  const getMessage = () => {
    if (error) return "Não foi possível buscar seus débitos. Tente novamente.";
    return "Esse veículo já possui um meio de pagamento automático cadastrado, sua cobrança é automática e não é preciso buscar débitos no Pedágio Digital.";
  }

  return (
    <div className="w-full h-full bg-[url('./assets/home-mobile-3x.png')] md:bg-[url('./assets/home-desk-2x.png')] bg-cover bg-fixed bg-center">
      <div className="absolute inset-0 bg-black bg-opacity-50 backdrop-grayscale-0"></div>
      <main className="relative h-full w-full min-h-screen flex flex-col justify-between">
        <header className="w-full md:max-w-7xl md:mx-auto flex flex-col md:flex-row items-center p-3 ">
          <div className="flex items-center w-full md:w-1/2 justify-between md:justify-start">
            <Icon className='dark' />
            <button
              onClick={toggleMenu}
              data-collapse-toggle="navbar-default"
              type="button"
              className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-white border rounded-lg md:hidden focus:outline-none focus:ring-2 dark:text-gray-400"
              aria-controls="navbar-default"
              aria-expanded="false"
            >
              <span className="sr-only">{isVisibleMenu ? "Close main menu" : "Open main menu"}</span>
              <img
                src={isVisibleMenu ? "./icon-menu-close.png" : "./icon-menu.png"}
                alt="ícone menu"
                width={24}
                height={24}
              />
            </button>
          </div>
          <nav className="flex w-full md:w-1/2 justify-end mt-2 md:mt-0">
            <ul
              id="navbar-default"
              className={`
                ${!isVisibleMenu ? "hidden" : ""}
                mt-2 md:mt-0
                rounded-lg bg-white p-2 text-black
                md:bg-transparent md:text-white md:flex md:p-0
                w-full md:w-auto
                flex-col md:flex-row
                items-center
                text-center
                md:justify-end
              `}
            >
              <li className="p-2">
                <button onClick={toggleModalLogin} className="text-black md:text-white">Fazer Login</button>
              </li>
              <li className="p-2">
                <Link to="/faq" className="text-black md:text-white">Perguntas frequentes</Link>
              </li>
              <li className="p-2">
                <button className='md:border md:border-1 md:rounded-lg md:p-2 md:px-4 text-black md:text-white' onClick={goToCreateAccount}>
                  Criar Conta
                </button>
              </li>
            </ul>
          </nav>
        </header>

        <article className="mt-5 md:h-[calc(100%-145px)] flex-1 flex p-3 justify-center items-center md:justify-around flex-col md:flex-row md:max-w-7xl md:mx-auto w-full">
          <div className="flex w-full justify-center flex-col p-3 text-left md:text-left">
            <h1 className="text-2xl md:text-[4rem] font-bold leading-normal uppercase text-white">Desfrute de toda a comodidade do pedágio <span className="text-principal uppercase">DIGITAL</span></h1>
            <h2 className="text-sm md:text-lg text-white mt-2">Uma nova era para o pedágio começou: ágil e digital como tem que ser.</h2>
          </div>
          <form className="w-full md:max-w-96 flex justify-start items-center flex-col bg-gray-200 rounded-xl p-6 min-h-96 md:max-h-calc(480px) mt-4 md:mt-0" onSubmit={isDisabled ? () => null : goToDebts}>
            <h3 className="w-full text-black text-xl mb-3">Um <span className="font-bold">único</span> lugar para <span className="font-bold">acessar</span> e <span className="font-bold">controlar</span> seus pagamentos.</h3>
            <InputMask
              value={user?.plate as string ?? ''}
              name="plate"
              placeholder="Digite sua placa"
              className="uppercase w-full h-14 rounded-xl p-3 text-black mt-2"
              mask="___-.@.."
              replacement={{ _: /\D/, ".": /\d/, "@": /[A-Za-z0-9]*/ }}
              onChange={onChange}
              type="text"
            />
            <div className='flex flex-col items-start justify-start mt-4 w-full gap-2'>
              <label className="flex items-center cursor-pointer select-none">
                <input
                  type="checkbox"
                  checked={isAcceptedTerms}
                  onChange={toggleTerms}
                  className="w-6 h-6 accent-black mr-2 mt-1"
                />
                <div className='flex flex-1'>
                  <span className="text-sm text-black">
                    Aceito os <Link to="/terms" className="underline italic text-gray-500" target="_blank">Termos e Condições de Uso</Link>.
                  </span>
                </div>
              </label>
              <label className="flex cursor-pointer select-none">
                <input
                  type="checkbox"
                  checked={isAcceptedPrivacy}
                  onChange={togglePrivacy}
                  className="flex w-6 h-6 accent-black mr-2 mt-1"
                />
                <div className='flex flex-1'>
                  <span className="text-sm text-black">
                    Estou ciente da <a href="/politicas-de-privacidade.html" className="underline italic text-gray-500" target="_blank" rel="noopener noreferrer">Política de Privacidade</a> e me responsabilizo pela veracidade dos dados.
                  </span>
                </div>
              </label>
            </div>
            <div className="mtcaptcha" data-callback="onCaptchaSuccess"></div>
            <button
              type="submit"
              className={`w-full mt-6 h-14 text-principal border p-3 rounded-xl ${isDisabled ? "bg-gray-300 text-white" : "bg-black border-black hover:bg-transparent hover:text-black"}`}
              disabled={isDisabled}>
              Buscar débitos
            </button>
            <button type="button" className='mt-6 text-large text-black underline' onClick={toggleModalLogin}>
              Começar agora
            </button>
          </form>
        </article>
      </main>
      {isVisibleModalLogin && <LoginModal toggleModalLogin={toggleModalLogin} />}
      {isVisibleModal && <Modal
        title="Atenção!"
        message={getMessage()}
        actionMessage="Fechar"
        action={toggleModal}
      />}
      {isLoading && <Loading />}
      <Footer />
    </div>
  );
}
